var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChannelLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.80813 9.4084C6.32152 9.37982 5.83436 9.45438 5.37857 9.62718C4.92278 9.79999 4.50865 10.0672 4.1633 10.4112L3.34226 11.2322C2.689 11.8855 2.32201 12.7715 2.32201 13.6953C2.32201 14.6192 2.689 15.5052 3.34226 16.1584C3.99552 16.8117 4.88153 17.1787 5.80537 17.1787C6.72922 17.1787 7.61523 16.8117 8.26849 16.1584L9.08952 15.3374C9.43337 14.9919 9.70043 14.5778 9.87323 14.122C10.046 13.6662 10.1207 13.1791 10.0923 12.6926",
    stroke: "#7A49B9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90771 7.30932C8.87908 6.8227 8.95361 6.33553 9.12642 5.87973C9.29923 5.42393 9.56642 5.0098 9.91047 4.66448L10.7315 3.84345C11.3848 3.19019 12.2708 2.82319 13.1946 2.82319C14.1185 2.82319 15.0045 3.19019 15.6577 3.84345C16.311 4.4967 16.678 5.38271 16.678 6.30656C16.678 7.2304 16.311 8.11641 15.6577 8.76967L14.8367 9.59071C14.4913 9.93464 14.0771 10.2017 13.6214 10.3745C13.1656 10.5474 12.6785 10.622 12.1919 10.5935",
    stroke: "#7A49B9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62573 12.875L12.373 7.12774",
    stroke: "#7A49B9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelLink);
export default __webpack_public_path__ + "static/media/ChannelLink.01424a8c.svg";
export { ForwardRef as ReactComponent };